
import CryptoJS from 'crypto-js'

export function aesDecrypt(url) {
    // 使用Fetch API下载图片
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET"
      })
        .then(response => {
          if (response.ok) {
            return response.arrayBuffer();
          } else {
            throw new Error('网络请求错误');
          }
        })
        .then(encryptedData => {
          const downloadUrl = decryptFBX(encryptedData);
          resolve(downloadUrl);
  
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    })
  
  };
  
  const decryptFBX = (encryptedData) => {
    const key = "Isgh2_c^&@uvAIK4"; // AES 密钥，必须与加密时使用的密钥相同
  
    // 解密过程
    const decryptedBytes = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.lib.WordArray.create(encryptedData) },
      CryptoJS.enc.Utf8.parse(key),
      { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
    );
  
    // 将解密后的字节数组转换为 Uint8Array
    const decryptedArray = new Uint8Array(decryptedBytes.sigBytes);
    for (let i = 0; i < decryptedBytes.sigBytes; i++) {
      decryptedArray[i] = decryptedBytes.words[i >>> 2] >>> (24 - (i % 4) * 8) & 0xff;
    }

    // console.log('uint8:',decryptedArray)

    return Array.from(decryptedArray);
  }